class ProductInfoCarousel extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.getAttribute('data-section-id')
    this.carousel = null

    this.initSwiper()
  }

  initSwiper () {
    this.carousel = new Swiper(`[data-swiper="${this.sectionId}"]`, {
      breakpoints: {
        990: {
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
          slidesPerView: 1.75,
          spaceBetween: 64,
        },
      },
      on: {
        init: (swiper) => {
          const nextBtns = this.querySelectorAll('[data-button-next]')

          if (nextBtns.length) {
            Array.from(nextBtns).forEach(btn => {
              btn.addEventListener('click', function () {
                swiper.slideNext()
              })
            })
          }
        }
      },
      navigation: {
        nextEl: `[data-button-next-mobile="${this.sectionId}"]`,
        prevEl: `[data-button-prev-mobile="${this.sectionId}"]`
      },
      slidesOffsetAfter: 24,
      slidesOffsetBefore: 24,
      slidesPerView: 1.15,
      spaceBetween: 24,
    })
  }
}

if (!customElements.get('product-info-carousel')) {
  customElements.define('product-info-carousel', ProductInfoCarousel)
}